module.exports = __webpack_public_path__ + "img/f-08.d3abe365.jpg";